// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FreeformQuestion-cls1___de0b6a835363b511611{/*!*/}.FreeformQuestion-cls2__c881368dd9028055594e{font-size:16px;display:grid;grid-row-gap:8px;row-gap:8px;grid-column-gap:12px;-moz-column-gap:12px;column-gap:12px;align-items:center;margin-bottom:8px}.FreeformQuestion-cls2__c881368dd9028055594e.FreeformQuestion-labeled___e70bb8473aeac44604a{grid-template-columns:min-content auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "FreeformQuestion-cls1___de0b6a835363b511611",
	"cls2": "FreeformQuestion-cls2__c881368dd9028055594e FreeformQuestion-cls1___de0b6a835363b511611",
	"labeled": "FreeformQuestion-labeled___e70bb8473aeac44604a"
};
export default ___CSS_LOADER_EXPORT___;
